import { inject, Injectable } from '@angular/core';
import { ApiDependencyProviderService } from '@web/common';
import { map, Observable } from 'rxjs';
import { blank, valueOrDefault } from '@web/utils';
import { AdminShippingSettingsResponse } from '../responses/admin-shipping-settings.response';
import { AdminShippingSettingsUpdateRequest } from '../requests/admin-shipping-settings-update.request';

@Injectable({
  providedIn: 'root',
})
export class AdminShippingSettingsApiService {
  private readonly provider = inject(ApiDependencyProviderService);

  public fetchSettings(options: {
    skipByLoading?: boolean;
  }): Observable<AdminShippingSettingsResponse> {
    const path = 'admin/settings/shipping';
    const url = this.provider.httpUrlFactory.withQueryParams(
      this.hostUrl(),
      path,
      {},
    );
    const context = this.provider.httpContextBuilder
      .skipByHttpErrorInterceptor()
      .withOptionalSkipByLoadingInterceptor(() =>
        valueOrDefault(options?.skipByLoading, false),
      )
      .build();

    return this.provider.http
      .get(url, { context })
      .pipe(
        map(
          this.provider.httpHelper.bodyToResponse(
            AdminShippingSettingsResponse,
          ),
        ),
      );
  }

  public updateSettings(
    request: AdminShippingSettingsUpdateRequest,
  ): Observable<void> {
    const path = 'admin/settings/shipping';
    const url = this.provider.httpUrlFactory.withQueryParams(
      this.hostUrl(),
      path,
      {},
    );
    const body = this.provider.httpHelper.requestToBody(
      request,
      AdminShippingSettingsUpdateRequest,
    );
    const context = this.provider.httpContextBuilder
      .skipByHttpErrorInterceptor()
      .build();

    return this.provider.http.put(url, body, { context }).pipe(blank());
  }

  private hostUrl(): string {
    return this.provider.environment.ApiHostUrl.Shop;
  }
}
